"use strict";

import $ from "jquery";

export default class QueryInfoWidget {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;
    this.$input = $("input", this.$selector);
    this.searchUrl = this.$input.data('action')
    
    if (selfInit) this.init();
  }

  init() {
    $("input", this.$selector).on("keyup", (e) => {
      if (e.keyCode == 13 || e.which == 13) {
        e.preventDefault();

        this.querySearch();
      }
    });

    $("button", this.$selector).on("click", (e) => {
      e.preventDefault();

      this.querySearch();
    });
  }

  querySearch() {
    this.inputValue = this.$input.val();
    const query = encodeURIComponent(this.inputValue);
    const url = `${this.searchUrl}?query=${query}`;

    window.location.href = url;
  }
}
